import apiClient from './apiClient';

export const employeeApi = {
    // ---- Employees ----
    getEmployees: () => apiClient.get('/api/employee').then(res => res.data),
    createEmployee: (data) => apiClient.post('/api/employee', data).then(res => res.data),
    updateEmployee: (id, data) => apiClient.put(`/api/employee/${id}`, data).then(res => res.data),
    deleteEmployee: (id) => apiClient.delete(`/api/employee/${id}`).then(res => res.data),

    // ---- Stats ----
    getStats: () => apiClient.get('/api/employee/stats').then(res => res.data),

    // ---- Employee Categories ----
    getCategories: () => apiClient.get('/api/employee/categories').then(res => res.data),
    createCategory: (data) => apiClient.post('/api/employee/categories', data).then(res => res.data),
    updateCategory: (id, data) => apiClient.put(`/api/employee/categories/${id}`, data).then(res => res.data),
    deleteCategory: (id, force = false) => apiClient.delete(`/api/employee/categories/${id}?force=${force}`).then(res => res.data),

    // ---- Absences (reuse leader routes for now) ----
    getWorkerAbsences: (workerId, params) => apiClient.get(`/api/leader/workers/${workerId}/absences`, { params }).then(res => res.data),
    createWorkerAbsence: (workerId, data) => apiClient.post(`/api/leader/workers/${workerId}/absences`, data).then(res => res.data),
    updateAbsence: (id, data) => apiClient.put(`/api/leader/absences/${id}`, data).then(res => res.data),
    deleteAbsence: (id) => apiClient.delete(`/api/leader/absences/${id}`).then(res => res.data),

    // ---- Document Types ----
    getDocumentTypes: () => apiClient.get('/api/employee/document-types').then(res => res.data),
    createDocumentType: (data) => apiClient.post('/api/employee/document-types', data).then(res => res.data),
    updateDocumentType: (id, data) => apiClient.put(`/api/employee/document-types/${id}`, data).then(res => res.data),
    deleteDocumentType: (id, force = false) => apiClient.delete(`/api/employee/document-types/${id}?force=${force}`).then(res => res.data),

    // ---- Employee Documents ----
    getDocuments: (workerId) => apiClient.get('/api/employee/documents', { params: workerId ? { worker_id: workerId } : {} }).then(res => res.data),
    createDocument: (data) => apiClient.post('/api/employee/documents', data).then(res => res.data),
    updateDocument: (id, data) => apiClient.put(`/api/employee/documents/${id}`, data).then(res => res.data),
    deleteDocument: (id) => apiClient.delete(`/api/employee/documents/${id}`).then(res => res.data),

    // ---- Document Attachments ----
    addDocumentAttachments: (docId, formData) => apiClient.post(`/api/employee/documents/${docId}/attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data),
    deleteDocumentAttachment: (docId, attachmentId) => apiClient.delete(`/api/employee/documents/${docId}/attachments/${attachmentId}`).then(res => res.data),
};
